// extracted by mini-css-extract-plugin
export default {"fontFamily":"Products_fontFamily__SJzcu","tableBg":"Products_tableBg__-MApO"};